import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import { Link } from 'gatsby';
import React, { useContext } from 'react';

import { ArrowLeft, ArrowRight } from '../Icon';
import Section from '../Layouts/Section/Section';
import * as styles from './Pagination.module.css';

const Pagination = ({
	pageContext,
	slug,
	background = 'grey',
	maxPagesShown = 5,
}: {
	pageContext: any;
	slug: string;
	background?: 'grey' | 'white';
	maxPagesShown?: number;
}) => {
	const { variant } = useContext(ThemeContext);
	const { currentPage, numberOfPages } = pageContext;
	const isFirst = currentPage === 1;
	const isLast = currentPage === numberOfPages;
	const prevPage =
		currentPage - 1 === 1
			? `/${slug}/`
			: `/${slug}/${(currentPage - 1).toString()}`;
	const nextPage = `/${slug}/${(currentPage + 1).toString()}`;

	const oddMaxPagesShown =
		maxPagesShown % 2 === 0 ? maxPagesShown - 1 : maxPagesShown;
	const maxPages =
		numberOfPages < oddMaxPagesShown ? numberOfPages : oddMaxPagesShown;
	const pagesEitherSide = Math.floor(oddMaxPagesShown / 2);

	const firstPage =
		currentPage <= pagesEitherSide
			? 1
			: currentPage < numberOfPages - pagesEitherSide ||
				  currentPage == maxPages - pagesEitherSide
				? currentPage - pagesEitherSide
				: numberOfPages > maxPages
					? numberOfPages - (maxPages - 1)
					: 1;

	return (
		<Section background={background}>
			<div className={styles.container}>
				{!isFirst && (
					<Link
						to={prevPage}
						rel="prev"
						className={cx(styles[variant], styles.action)}>
						<ArrowLeft /> <span>Previous</span>
					</Link>
				)}
				<div className={styles.pages}>
					{Array.from({ length: maxPages }, (_, i) => (
						<Link
							key={`pagination-number${firstPage + i}`}
							to={`/${slug}/${firstPage + i === 1 ? '' : firstPage + i}`}
							className={cx(styles[variant], styles.number)}
							activeClassName={styles.active}>
							{firstPage + i}
						</Link>
					))}
				</div>
				{!isLast && (
					<Link
						to={nextPage}
						rel="next"
						className={cx(styles[variant], styles.action)}>
						<span>Next</span> <ArrowRight />
					</Link>
				)}
			</div>
		</Section>
	);
};

export default Pagination;
